// extracted by mini-css-extract-plugin
export default {"Wrapper":"Shop_Wrapper__dZc0j","Container":"Shop_Container__Q4Vb4","Item":"Shop_Item__5wxxe"};